import { render, staticRenderFns } from "./SystemAlerts.vue?vue&type=template&id=07b2b2d6&"
import script from "./SystemAlerts.vue?vue&type=script&lang=js&"
export * from "./SystemAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b2b2d6')) {
      api.createRecord('07b2b2d6', component.options)
    } else {
      api.reload('07b2b2d6', component.options)
    }
    module.hot.accept("./SystemAlerts.vue?vue&type=template&id=07b2b2d6&", function () {
      api.rerender('07b2b2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemAlerts.vue"
export default component.exports